<template>
  <div class="container">
    <div class="row justify-content-center align-items-center mh-100vh">
      <div class="col-lg-5 col-md-8">
        <div class="card ps-2 text-white main-color mb-1">
          <div class="card-body h2">
            {{this.config.projectName}}
          </div>
        </div>
        <div class="card-group">
          <div class="card p-4">
            <BOverlay :show="overlayShow" rounded="sm">
              <div class="card-body">
                <div class="input-group mb-3">
                <span>届いた認証番号を入力してください</span>
                </div>
                <div class="input-group">
                  <input class="form-control" type="text" v-model="oneTimePassword" :class="{'is-invalid' : validation.hasError('oneTimePassword')}" autocomplete="off">
                  <div class="invalid-feedback">{{ validation.firstError('oneTimePassword') }}</div>
                </div>
                <div class="row mt-3">
                  <div class="col-12">
                    <BButton block variant="primary" @click.stop.prevent="confirm()">確認</BButton>
                  </div>
                </div>
              </div>
            </BOverlay>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { createApp } from 'vue'
import MeetingStartModel from '@/models/MeetingStartModel'
// import SimpleVueValidation from 'simple-vue-validator'
// const Validator = SimpleVueValidation.Validator
// const app = createApp({})

// app.use(SimpleVueValidation)

export default {
  name: 'CustomerSNSAuth',
  components: {MeetingStartModel},
  data () {
    return {
      overlayShow: false,
      oneTimePassword: ''
    }
  },
  methods: {
    confirm: async function () {
      let isError = await this.$validate()
        .then((success) => {
          return !success
        })

      if (isError) {
        return false
      }

      const params = {'oneTimePassword': this.oneTimePassword, 'attendeeType': this.consts.attendeeType.customer}

      this.overlayShow = true
      const meetingStartModel = await MeetingStartModel.apiSetStore(this.$bvModal, params, () => {
        this.overlayShow = false
      })
      sessionStorage.meeting = await JSON.stringify(meetingStartModel.meeting)
      sessionStorage.attendee = await JSON.stringify(meetingStartModel.attendee)
      this.$router.push('/customer/meeting/agenda')
    }
  },
  unmounted () {
    if (MeetingStartModel.getStore()) {
      MeetingStartModel.removeStore()
    }
  }
}
</script>
